export default __webpack_public_path__ + "static/media/no-bridge-fees-text.4413c1ad.svg";